import React, { useState } from "react";
import ModalLoading from "../../components/ModalLoading";
import CardUser from "../../components/Card/CardUser";
import _ from "lodash";
import useAPI from "../../hooks/useAPI";

export default function UserDetailsFragment({ dataAccount, token }) {
  const [users, loadingUsers] = useAPI(
    "/users",
    {
      applicationType: "WALLET",
      retailer: dataAccount?.id,
      walletAdmin: false,
      limit: 10000,
    },
    { Authorization: `Bearer ${token}` },
  );

  const [showModalLoading, setShowModalLoading] = useState(false);

  return (
    <>
      <ModalLoading
        showModal={showModalLoading}
        setShowModal={setShowModalLoading}
      />

      <div className="overflow-y-scroll">
        <div className="space-y-3">
          {_.isEmpty(users) ? (
            <div className="h-28 w-full border-2 border-dashed">
              <div className="flex h-full w-full items-center justify-center space-x-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className={`h-5 w-5 text-gray-400 ${loadingUsers && "animate-pulse"}`}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"
                  />
                </svg>
                <span
                  className={`text-sm text-gray-400 ${loadingUsers && "animate-pulse"}`}
                >
                  {loadingUsers ? "Loading..." : "You don't have an users"}
                </span>
              </div>
            </div>
          ) : (
            users.map((user) => (
              <CardUser
                data={user}
                enActionEdit={false}
                enActionDelete={false}
                isDisable={false}
              />
            ))
          )}
        </div>
      </div>
    </>
  );
}
